export default __webpack_public_path__ + "static/media/ic-attempted result.46a745ad.svg";